import type { RefObject, UIEvent } from 'react';
import type { FolderResult, MismatchDetail, DifferenceItem } from '../../../infrastructure/models';

export const FOLDER_STATUS_COLORS: Record<string, string> = {
  Matching: 'green',
  Modified: 'orange',
  OnlyInA: 'blue',
  OnlyInB: 'cyan',
  Failed: 'red',
};

export const DIFF_TYPE_COLORS: Record<string, string> = {
  Modified: '#fbbf24',
  Added: '#e67700',
  Removed: '#ef4444',
  Unmatched: '#9ca3af',
  Matching: '#4ade80',
};

export const DIFF_TYPE_LABELS: Record<string, string> = {
  Modified: 'Changed',
  Added: 'Only in Target',
  Removed: 'Only in Source',
  Unmatched: 'Unable to Pair',
  Matching: 'Matched',
};

export const getDiffTypeLabel = (differenceType: string, envAName: string, envBName: string): string => {
  switch (differenceType) {
    case 'Modified': return 'Changed';
    case 'Added': return `Only in ${envBName}`;
    case 'Removed': return `Only in ${envAName}`;
    case 'Unmatched': return 'Unable to Pair';
    case 'Matching': return 'Matched';
    default: return differenceType;
  }
};

export type FilterValue = 'all' | 'Modified' | 'Added' | 'Removed' | 'Unmatched' | 'Matched';

export interface FlatDifference {
  folderIndex: number;
  mismatchIndex: number;
  key: string;
}

export interface EnvironmentNames {
  envAName: string;
  envBName: string;
}

export interface EnvironmentPaneProps extends EnvironmentNames {
  side: 'A' | 'B';
  folder: FolderResult | null;
  filteredMismatches: MismatchDetail[];
  filteredDiffItems: DifferenceItem[];
  activeDifferenceKey: string | undefined;
  scrollRef: RefObject<HTMLDivElement | null>;
  onScroll: (event: UIEvent<HTMLDivElement>) => void;
  collapsedSections: Set<string>;
  onToggleSection: (configName: string) => void;
  onShowMore: (record: MismatchDetail) => void;
}

export interface FolderNavigatorProps extends EnvironmentNames {
  folderResults: FolderResult[];
  selectedFolderIndex: number;
  onSelectFolder: (index: number) => void;
  filterValue: FilterValue;
  onFilterChange: (value: FilterValue) => void;
}

export interface CompareModalProps extends EnvironmentNames {
  record: MismatchDetail | null;
  onClose: () => void;
}
